(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-custom"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ig-featured-pendants')) {

  customElements.define(
    'ig-featured-pendants',
    class extends HTMLElement {

      connectedCallback() {

        this.abort?.abort();

        this.abort =
          new AbortController();

        const options = {
          signal:
            this.abort.signal
        };

        this.panels = [
          ...this.querySelectorAll(
            '[data-panel]'
          )
        ];

        this.details = [
          ...this.querySelectorAll(
            '[data-details]'
          )
        ];

        this.stage =
          this.querySelector(
            '[data-stage]'
          );

        this.index = 0;
        this.drag = null;
        this.suppressClick = false;

        if (
          !this.panels.length ||
          !this.stage
        ) {
          return;
        }

        this.classList.add(
          'is-ready'
        );

        this.show(
          0,
          false
        );

        this.addEventListener(
          'click',
          event => {

            if (
              this.suppressClick
            ) {
              event.preventDefault();
              return;
            }

            const choice =
              event.target.closest(
                '[data-select]'
              );

            if (choice) {

              this.show(
                Number(
                  choice.dataset.select
                )
              );

              return;

            }

            if (
              event.target.closest(
                '[data-previous]'
              )
            ) {

              this.show(
                this.index - 1
              );

              return;

            }

            if (
              event.target.closest(
                '[data-next]'
              )
            ) {

              this.show(
                this.index + 1
              );

              return;

            }

            const angle =
              event.target.closest(
                '[data-angle]'
              );

            if (angle) {
              this.selectMedia(
                angle
              );
            }

          },
          options
        );

        this.addEventListener(
          'keydown',
          event => {

            if (
              event.target.closest(
                'video,input,textarea,select,a,[contenteditable]'
              )
            ) {
              return;
            }

            if (
              event.key === 'ArrowLeft' ||
              event.key === 'ArrowRight'
            ) {

              event.preventDefault();

              this.show(
                this.index +
                (
                  event.key === 'ArrowRight'
                    ? 1
                    : -1
                )
              );

            }

          },
          options
        );

        this.stage.addEventListener(
          'dragstart',
          event =>
            event.preventDefault(),
          options
        );

        this.stage.addEventListener(
          'pointerdown',
          event => {

            if (
              !event.isPrimary ||
              event.button !== 0 ||
              this.panels.length < 2
            ) {
              return;
            }

            if (
              event.target.closest(
                '[data-angle],video'
              )
            ) {
              return;
            }

            this.drag = {
              id:
                event.pointerId,

              x:
                event.clientX,

              y:
                event.clientY,

              delta:
                0,

              started:
                false
            };

          },
          options
        );

        this.stage.addEventListener(
          'pointermove',
          event => {

            const drag =
              this.drag;

            if (
              !drag ||
              drag.id !== event.pointerId
            ) {
              return;
            }

            const dx =
              event.clientX -
              drag.x;

            const dy =
              event.clientY -
              drag.y;

            if (
              !drag.started
            ) {

              if (
                Math.abs(dy) >
                Math.abs(dx) &&
                Math.abs(dy) > 8
              ) {

                this.drag = null;
                return;

              }

              if (
                Math.abs(dx) < 8
              ) {
                return;
              }

              drag.started =
                true;

              this.stage.setPointerCapture(
                event.pointerId
              );

              this.classList.add(
                'is-dragging'
              );

            }

            drag.delta =
              dx;

            const step =
              Math.max(
                140,
                this.panels[
                  this.index
                ].offsetWidth * .65
              );

            this.draw(
              this.index -
              Math.max(
                -.95,
                Math.min(
                  .95,
                  dx / step
                )
              ),
              true
            );

          },
          options
        );

        const finish =
          (
            event,
            cancelled = false
          ) => {

            const drag =
              this.drag;

            if (
              !drag ||
              drag.id !== event.pointerId
            ) {
              return;
            }

            this.drag =
              null;

            this.classList.remove(
              'is-dragging'
            );

            if (
              this.stage.hasPointerCapture(
                event.pointerId
              )
            ) {

              this.stage.releasePointerCapture(
                event.pointerId
              );

            }

            if (
              !drag.started
            ) {
              return;
            }

            this.suppressClick =
              true;

            clearTimeout(
              this.clickTimer
            );

            this.clickTimer =
              setTimeout(
                () => {
                  this.suppressClick =
                    false;
                },
                250
              );

            const threshold =
              Math.max(
                35,
                this.panels[
                  this.index
                ].offsetWidth * .12
              );

            const shift =
              !cancelled &&
              Math.abs(
                drag.delta
              ) > threshold
                ? (
                    drag.delta < 0
                      ? 1
                      : -1
                  )
                : 0;

            this.show(
              this.index +
              shift
            );

          };

        this.stage.addEventListener(
          'pointerup',
          event =>
            finish(event),
          options
        );

        this.stage.addEventListener(
          'pointercancel',
          event =>
            finish(
              event,
              true
            ),
          options
        );

        this.stage.addEventListener(
          'lostpointercapture',
          event =>
            finish(
              event,
              true
            ),
          options
        );

        document.addEventListener(
          'shopify:block:select',
          event => {

            const index =
              this.panels.findIndex(
                panel =>
                  panel.dataset.blockId ===
                  event.detail?.blockId
              );

            if (
              index >= 0
            ) {
              this.show(
                index
              );
            }

          },
          options
        );

        this.resize =
          new ResizeObserver(
            () =>
              this.draw(
                this.index
              )
          );

        this.resize.observe(
          this.stage
        );

      }

      draw(
        position,
        preview = false
      ) {

        const n =
          this.panels.length;

        const cardWidth =
          this.panels[0].offsetWidth;

        const stepAngle =
          Math.min(
            42,
            360 /
            Math.max(
              1,
              n
            )
          );

        const radius =
          cardWidth * 1.08;

        this.panels.forEach(
          (panel, i) => {

            let offset =
              (
                (
                  i -
                  position
                ) %
                n +
                n
              ) %
              n;

            if (
              offset >
              n / 2
            ) {
              offset -= n;
            }

            const angle =
              offset *
              stepAngle;

            const radians =
              angle *
              Math.PI /
              180;

            const x =
              Math.sin(
                radians
              ) *
              radius;

            const z =
              (
                Math.cos(
                  radians
                ) -
                1
              ) *
              cardWidth *
              1.45;

            const visible =
              Math.abs(
                offset
              ) < 2.6;

            const opacity =
              visible
                ? Math.max(
                    .24,
                    1 -
                    Math.abs(
                      offset
                    ) *
                    .24
                  )
                : 0;

            panel.style.transform =
              `translateX(-50%) translate3d(${x}px, ${Math.abs(offset) * 12}px, ${z}px) rotateY(${-angle * .58}deg)`;

            panel.style.opacity =
              String(
                opacity
              );

            panel.style.zIndex =
              String(
                20 -
                Math.round(
                  Math.abs(
                    offset
                  ) *
                  5
                )
              );

            panel.classList.toggle(
              'is-visible',
              visible
            );

            if (
              !preview
            ) {

              panel.inert =
                !visible;

              panel.setAttribute(
                'aria-hidden',
                String(
                  !visible
                )
              );

            }

          }
        );

      }

      show(
        index,
        animate = true
      ) {

        if (
          !this.panels.length
        ) {
          return;
        }

        const next =
          (
            (
              index %
              this.panels.length
            ) +
            this.panels.length
          ) %
          this.panels.length;

        const changed =
          next !==
          this.index;

        this.index =
          next;

        const outgoingFocus =
          this.panels.some(
            (panel, i) =>
              i !== next &&
              panel.contains(
                document.activeElement
              )
          );

        this.panels.forEach(
          (panel, i) => {

            const active =
              i === next;

            panel.classList.toggle(
              'is-active',
              active
            );

            const angles =
              panel.querySelector(
                '.igfs__angles'
              );

            if (angles) {
              angles.inert =
                !active;
            }

            const select =
              panel.querySelector(
                '[data-select]'
              );

            if (select) {
              select.hidden =
                active;
            }

            panel
              .querySelectorAll(
                'video'
              )
              .forEach(
                video => {

                  video.inert =
                    !active;

                  if (
                    !active
                  ) {
                    video.pause();
                  }

                }
              );

          }
        );

        this.motion?.cancel();

        this.details.forEach(
          (details, i) => {

            const active =
              i === next;

            details.classList.toggle(
              'is-active',
              active
            );

            details.inert =
              !active;

            details.setAttribute(
              'aria-hidden',
              String(
                !active
              )
            );

          }
        );

        this.draw(
          next
        );

        const current =
          this.details[next];

        if (
          changed &&
          animate &&
          current?.animate &&
          !matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
        ) {

          this.motion =
            current.animate(
              [
                {
                  opacity:
                    0,

                  transform:
                    'translateY(12px)'
                },

                {
                  opacity:
                    1,

                  transform:
                    'translateY(0)'
                }
              ],
              {
                duration:
                  650,

                easing:
                  'cubic-bezier(.16,1,.3,1)'
              }
            );

        }

        if (
          outgoingFocus
        ) {

          this.panels[next].focus({
            preventScroll:
              true
          });

        }

        const status =
          this.querySelector(
            '[data-status]'
          );

        if (
          status &&
          changed
        ) {

          status.textContent =
            `${current?.querySelector('.igfs__title')?.textContent.trim() || 'Pendant'}, ${next + 1} of ${this.panels.length}`;

        }

      }

      selectMedia(
        angle
      ) {

        const panel =
          angle.closest(
            '[data-panel]'
          );

        if (
          panel !==
          this.panels[
            this.index
          ]
        ) {
          return;
        }

        const image =
          panel.querySelector(
            '.igfs__main-image'
          );

        panel
          .querySelectorAll(
            '[data-video-player]'
          )
          .forEach(
            player => {

              player.hidden =
                true;

              player
                .querySelector(
                  'video'
                )
                ?.pause();

            }
          );

        if (
          angle.hasAttribute(
            'data-video-trigger'
          )
        ) {

          const player =
            panel.querySelector(
              `[data-video-player="${angle.dataset.videoTrigger}"]`
            );

          const video =
            player?.querySelector(
              'video'
            );

          if (
            !video
          ) {
            return;
          }

          player.hidden =
            false;

          if (image) {
            image.hidden =
              true;
          }

          video
            .play()
            .catch(
              () => {}
            );

        }

        else {

          if (
            !image
          ) {
            return;
          }

          image.hidden =
            false;

          image.removeAttribute(
            'srcset'
          );

          image.src =
            angle.dataset.url;

          image.alt =
            angle.dataset.alt;

        }

        panel
          .querySelectorAll(
            '[data-angle]'
          )
          .forEach(
            button => {

              button.classList.toggle(
                'is-active',
                button === angle
              );

              button.setAttribute(
                'aria-pressed',
                String(
                  button === angle
                )
              );

            }
          );

      }

      disconnectedCallback() {

        this.abort?.abort();

        this.resize?.disconnect();

        this.motion?.cancel();

        clearTimeout(
          this.clickTimer
        );

        this
          .querySelectorAll(
            'video'
          )
          .forEach(
            video =>
              video.pause()
          );

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('change', function (event) {
    const input = event.target.closest(
      'input[type="radio"][name="grid"], input[type="radio"][name="grid-mobile"]'
    );

    if (!input) return;

    const resultsList = input.closest('results-list');

    const grid = resultsList
      ? resultsList.querySelector('[data-testid="product-grid"]')
      : document.querySelector('[data-testid="product-grid"]');

    if (!grid) return;

    const layout = input.value || 'default';

    grid.setAttribute(
      'product-grid-view',
      layout
    );

    try {
      sessionStorage.setItem(
        input.name === 'grid-mobile'
          ? 'product-grid-view-mobile'
          : 'product-grid-view-desktop',
        layout
      );
    } catch (error) {
      /* Session storage is optional. */
    }
  });


  /* =========================================================
     HIDE PAGE SCROLLBAR WITHOUT SHIFTING CONTENT
  ========================================================= */

  function igHidePageScrollbar() {
    const root = document.documentElement;

    if (
      !root.classList.contains(
        'ig-hide-page-scrollbar'
      )
    ) {
      const scrollbarWidth = Math.max(
        0,
        window.innerWidth - root.clientWidth
      );

      root.style.setProperty(
        '--ig-scrollbar-compensation',
        `${scrollbarWidth}px`
      );

      root.classList.add(
        'ig-hide-page-scrollbar'
      );
    }
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      igHidePageScrollbar,
      { once: true }
    );
  } else {
    igHidePageScrollbar();
  }


  document.addEventListener(
    'shopify:section:load',
    igHidePageScrollbar
  );
  /* =========================================================
   ICE GUYS — CUSTOM MOBILE SORT DROPDOWN
========================================================= */

function igInitCustomMobileSort() {
  const drawers = document.querySelectorAll('#filters-drawer');

  drawers.forEach((drawer) => {
    const nativeSelect = drawer.querySelector(
      '.sorting-filter__select'
    );

    if (!nativeSelect) return;

    const container = nativeSelect.closest(
      '.sorting-filter__container'
    );

    if (!container) return;

    /*
      Avoid creating the custom dropdown more than once.
    */
    if (
      container.querySelector(
        '.ig-mobile-sort-custom'
      )
    ) {
      return;
    }


    /* =====================================================
       HIDE NATIVE SELECT VISUALLY
       Keep it functional for Shopify filtering.
    ===================================================== */

    const nativeWrapper = nativeSelect.closest(
      '.sorting-filter__select-wrapper'
    );

    if (nativeWrapper) {
      nativeWrapper.classList.add(
        'ig-native-sort-hidden'
      );
    }


    /* =====================================================
       CUSTOM WRAPPER
    ===================================================== */

    const custom = document.createElement('div');

    custom.className =
      'ig-mobile-sort-custom';


    /* =====================================================
       TRIGGER
    ===================================================== */

    const trigger = document.createElement('button');

    trigger.type = 'button';

    trigger.className =
      'ig-mobile-sort-trigger';

    trigger.setAttribute(
      'aria-haspopup',
      'listbox'
    );

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );


    const triggerText =
      document.createElement('span');

    triggerText.className =
      'ig-mobile-sort-trigger__text';


    const selectedOption =
      nativeSelect.options[
        nativeSelect.selectedIndex
      ];

    triggerText.textContent =
      selectedOption
        ? selectedOption.textContent.trim()
        : 'Most relevant';


    const caret =
      document.createElement('span');

    caret.className =
      'ig-mobile-sort-trigger__caret';

    caret.setAttribute(
      'aria-hidden',
      'true'
    );

    caret.innerHTML = `
      <svg
        viewBox="0 0 12 8"
        width="12"
        height="8"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M1 1.5L6 6.5L11 1.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;


    trigger.appendChild(triggerText);
    trigger.appendChild(caret);


    /* =====================================================
       OPTIONS PANEL
    ===================================================== */

    const panel = document.createElement('div');

    panel.className =
      'ig-mobile-sort-menu';

    panel.setAttribute(
      'role',
      'listbox'
    );


    Array.from(nativeSelect.options).forEach(
      (option) => {
        const item =
          document.createElement('button');

        item.type = 'button';

        item.className =
          'ig-mobile-sort-option';

        item.setAttribute(
          'role',
          'option'
        );

        item.dataset.value =
          option.value;


        const text =
          document.createElement('span');

        text.className =
          'ig-mobile-sort-option__text';

        text.textContent =
          option.textContent.trim();


        const check =
          document.createElement('span');

        check.className =
          'ig-mobile-sort-option__check';

        check.setAttribute(
          'aria-hidden',
          'true'
        );

        check.innerHTML = `
          <svg
            viewBox="0 0 14 14"
            width="14"
            height="14"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M2.5 7.2L5.5 10L11.5 4"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        `;


        if (option.selected) {
          item.classList.add(
            'is-selected'
          );

          item.setAttribute(
            'aria-selected',
            'true'
          );
        } else {
          item.setAttribute(
            'aria-selected',
            'false'
          );
        }


        item.appendChild(text);
        item.appendChild(check);


        item.addEventListener(
          'click',
          () => {
            nativeSelect.value =
              option.value;


            /*
              Trigger Shopify's native sort behavior.
            */
            nativeSelect.dispatchEvent(
              new Event(
                'input',
                {
                  bubbles: true
                }
              )
            );

            nativeSelect.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );


            triggerText.textContent =
              option.textContent.trim();


            panel
              .querySelectorAll(
                '.ig-mobile-sort-option'
              )
              .forEach(
                (button) => {
                  const selected =
                    button.dataset.value ===
                    option.value;

                  button.classList.toggle(
                    'is-selected',
                    selected
                  );

                  button.setAttribute(
                    'aria-selected',
                    selected
                      ? 'true'
                      : 'false'
                  );
                }
              );


            custom.classList.remove(
              'is-open'
            );

            trigger.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        );


        panel.appendChild(item);
      }
    );


    /* =====================================================
       OPEN / CLOSE
    ===================================================== */

    trigger.addEventListener(
      'click',
      () => {
        const willOpen =
          !custom.classList.contains(
            'is-open'
          );


        document
          .querySelectorAll(
            '.ig-mobile-sort-custom.is-open'
          )
          .forEach(
            (dropdown) => {
              if (dropdown !== custom) {
                dropdown.classList.remove(
                  'is-open'
                );

                const otherTrigger =
                  dropdown.querySelector(
                    '.ig-mobile-sort-trigger'
                  );

                if (otherTrigger) {
                  otherTrigger.setAttribute(
                    'aria-expanded',
                    'false'
                  );
                }
              }
            }
          );


        custom.classList.toggle(
          'is-open',
          willOpen
        );

        trigger.setAttribute(
          'aria-expanded',
          willOpen
            ? 'true'
            : 'false'
        );
      }
    );


    custom.appendChild(trigger);
    custom.appendChild(panel);

    container.appendChild(custom);


    /* =====================================================
       KEEP CUSTOM TEXT SYNCED
       If Shopify changes the native selection.
    ===================================================== */

    nativeSelect.addEventListener(
      'change',
      () => {
        const selected =
          nativeSelect.options[
            nativeSelect.selectedIndex
          ];

        if (selected) {
          triggerText.textContent =
            selected.textContent.trim();
        }
      }
    );
  });
}



/* =========================================================
   CLOSE WHEN CLICKING OUTSIDE
========================================================= */

document.addEventListener(
  'click',
  (event) => {
    document
      .querySelectorAll(
        '.ig-mobile-sort-custom.is-open'
      )
      .forEach(
        (dropdown) => {
          if (
            !dropdown.contains(
              event.target
            )
          ) {
            dropdown.classList.remove(
              'is-open'
            );

            const trigger =
              dropdown.querySelector(
                '.ig-mobile-sort-trigger'
              );

            if (trigger) {
              trigger.setAttribute(
                'aria-expanded',
                'false'
              );
            }
          }
        }
      );
  }
);



/* =========================================================
   ESC TO CLOSE
========================================================= */

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll(
        '.ig-mobile-sort-custom.is-open'
      )
      .forEach(
        (dropdown) => {
          dropdown.classList.remove(
            'is-open'
          );

          const trigger =
            dropdown.querySelector(
              '.ig-mobile-sort-trigger'
            );

          if (trigger) {
            trigger.setAttribute(
              'aria-expanded',
              'false'
            );

            trigger.focus();
          }
        }
      );
  }
);



/* =========================================================
   INITIALIZE
========================================================= */

if (
  document.readyState ===
  'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    igInitCustomMobileSort,
    {
      once: true
    }
  );
} else {
  igInitCustomMobileSort();
}


/*
  Shopify Theme Editor reload.
*/
document.addEventListener(
  'shopify:section:load',
  () => {
    setTimeout(
      igInitCustomMobileSort,
      50
    );
  }
);


/*
  Filter drawer can be updated dynamically.
*/
const igSortObserver =
  new MutationObserver(() => {
    igInitCustomMobileSort();
  });


igSortObserver.observe(
  document.documentElement,
  {
    childList: true,
    subtree: true
  }
);

  } catch(e) { console.error(e); }
})();
})();
